import { createSelector } from 'reselect'

export const getPageMetaTagsSingle = createSelector(
  (state) => state && state.common && state.common.pageMetaTagsSingle && Array.isArray(state.common.pageMetaTagsSingle) && state.common.pageMetaTagsSingle.length ?
    state.common.pageMetaTagsSingle[0] : null,
  (pageMetaTagsSingle) => pageMetaTagsSingle
)
